<template>
  <v-col class="d-flex justify-end mb-4 px-2">
    <avs-button
      v-bind="{ ...$attrs }"
      v-on="{ ...$listeners }"
      classB="text-caption"
      color="accent"
      @click="back"
      rounded
      x-large
      iconI="mdi-keyboard-return"
      noSpantext
    >
      <template v-slot:name>{{ $t("commons.back") }}</template>
    </avs-button>
  </v-col>
</template>

<script>
export default {
  name: "BackButton",
  props: {
    backTo: {
      type: String,
      default: null
    }
  },
  methods: {
    back() {
      if (this.backTo) {
        this.$router.push({ name: this.backTo })
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>
